import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../service/user.service';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { User } from '@smartnowx/hcms-commons';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  loginForm!: FormGroup;

  errorMessage!: string;

  constructor( private fb: FormBuilder, private router: Router, private translate: TranslateService, private userService: UserService) {

  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: [null, [Validators.required, Validators.email]],
      password: [null, [Validators.required]]
    });
  }

  public login() {
    const { email, password } = this.loginForm.value;

    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      this.errorMessage = "login.email_password_wrong";
      return;
    }

    this.userService.login({ email: email, password: password } as User)
      .pipe(
        catchError(error => {
          console.error('Login error:', error);
          switch (error.status) {
            case 401:
              this.errorMessage = "login.email_password_wrong";
              break;
            case 403:
              this.errorMessage = "login.access_denied";
              break;
            case 500:
              this.errorMessage = "login.server_error";
              break;
            default:
              this.errorMessage = "login.login_failed";
              break;
          }
          return of(error);
        })
      ).subscribe((user) => {
        if (user) {
          this.router.navigate(['/menu']);
        } else {
          this.errorMessage = "login.permission_denied";
        }
      }, (error) => {
        console.error('Login failed:', error);
        this.errorMessage = "login.login_failed";
      });
  }
}
